define([ 'base/widgets/step/step-simple' ], function(Basestep) {
    Basestep.prototype.template =
        '<div id="{{ stepView.ID }}" wt ng-show="stepView.show" ng-repeat="stepView in viewModel">' +
        '<span id="{{stepView.numID}}" class="{{stepView.imgClzCur}}"></span>' +
        '<span id="{{stepView.titleID}}" class="{{stepView.titleClass}}" ng-bind="stepView.title"></span>' +
        '<span class="simple-next" ng-show="stepView.nextShow"><hr width="304" style=" display: inline-block;"></span>' +
        '</div>';

    return Basestep;
});



// WEBPACK FOOTER //
// ./public/hws/js/widgets/step/step-simple.js